import axios from "axios";
import params from "../configs/params";

const eatAppApi = axios.create({ baseURL: params.eatAppUrl, withCredentials: false });
eatAppApi.defaults.headers.common["Content-Type"] = "application/json";
eatAppApi.defaults.headers.common["ngrok-skip-browser-warning"] = "true";

eatAppApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

eatAppApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem("refreshToken");
      if (refreshToken) {
        const response = await axios.post(`${params.apiUrl}auth/token/refresh/`, {
          token: refreshToken,
        });
        const accessToken = response.data.accessToken;
        localStorage.setItem("accessToken", accessToken);
        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return eatAppApi(originalRequest);
      }
    }
    return Promise.reject(error);
  }
);

export default eatAppApi;
